import * as React from 'react'
function SvgClose(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M35.314 4.686c-.914-.915-2.285-.915-3.2 0L20 16.8 7.886 4.686c-.915-.915-2.286-.915-3.2 0-.915.914-.915 2.285 0 3.2L16.8 20 4.686 32.114c-.915.915-.915 2.286 0 3.2.457.457.914.686 1.6.686.685 0 1.143-.229 1.6-.686L20 23.2l12.114 12.114c.457.457 1.143.686 1.6.686.457 0 1.143-.229 1.6-.686.915-.914.915-2.285 0-3.2L23.2 20 35.314 7.886c.915-.915.915-2.286 0-3.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgClose
